import type { Driver } from '../../../../../types'
import { Edit } from '../../../../cars/components/V3/icons/Edit'
import { Lock } from '../../../../cars/components/V3/icons/Lock'
import type { DropdownItems } from '../../Form/GenericDropdown'

export const DriverDropdownItems = (
  driver: Driver,
  handlers: {
    editDriver?: (d: Driver) => void
    editAccess?: (d: Driver) => void
  },
): DropdownItems[] => {
  const { editDriver, editAccess } = handlers

  const items: DropdownItems[] = [
    {
      label: 'Rediger ansatt',
      icon: <Edit />,
      onSelect: () => editDriver?.(driver),
    },
  ]

  const hasEmailAndPhone = driver.email && driver.phoneNo
  if (hasEmailAndPhone) {
    items.push({
      label: 'Endre webtilgang',
      icon: <Lock />,
      onSelect: () => editAccess?.(driver),
    })
  }

  return items
}
